import { render, staticRenderFns } from "./EiTabBar.vue?vue&type=template&id=56e7a7d2&scoped=true&"
import script from "./EiTabBar.vue?vue&type=script&lang=js&"
export * from "./EiTabBar.vue?vue&type=script&lang=js&"
import style0 from "./EiTabBar.vue?vue&type=style&index=0&id=56e7a7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7a7d2",
  null
  
)

export default component.exports